/* Add IconsPlugin July 3, 2022 */
/* Add EventBus Apr 29, 2023 */
/* Add store June 29, 2026  */
import Vue from 'vue';
import 'bootstrap';
import {BootstrapVue,IconsPlugin} from 'bootstrap-vue';
import 'bootstrap-vue/dist/bootstrap-vue.min.css';
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "bootstrap-vue/dist/bootstrap-vue-icons.min.css";
import '../css/bootstrap-custom.css';
import VueCookies from 'vue-cookies';
import {FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText} from '@fortawesome/vue-fontawesome';

import App from './App.vue';
import {router, fn_authConfig} from './router.js';
import {fn_getAppInfoAuthConfig} from "@/utils/init.js";
import global from "../src/mixins/global";
import * as VueGoogleMaps from "vue2-google-maps";
import store from "@/store";
//import store from "./store";


Vue.use(BootstrapVue);
Vue.use(IconsPlugin)
Vue.use(VueCookies);
Vue.component('fa-icon', FontAwesomeIcon);
Vue.component('fa-layers', FontAwesomeLayers);
Vue.component('fa-layers-text', FontAwesomeLayersText);

export const eventBus = new Vue();

// Vue.config.productionTip = false;
// Vue.config.devtools = process.env.NODE_ENV == 'development';
// Vue.config.silent = true;


fn_getAppInfoAuthConfig().then((resp) => {
  let errMsg;
  if (resp.err || !resp.appInfo) {
    errMsg = 'Unable to load application - ' + (resp.err || 'Unknown Error');
  }
  else if (resp.authConfig) {
    Vue.component('kt-spinner', () => import("@/components/Ctrl/KT-Spinner.vue"));
    Vue.component('kt-select', () => import("@/components/Ctrl/KT-Select.vue"));
    Vue.component('kt-tt-info', () => import("@/components/Ctrl/KT-TTInfo.vue"));
    Vue.component('kt-com-fld', () => import("@/components/Ctrl/KT-ComFld.vue"));
    fn_authConfig(resp.authConfig);
  }

  // Vue.prototype.$open = window.open;
  
 // Map view
Vue.mixin(global);
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyAaLA2tFFMX6WB98vxqkgwEePxrZV2mnDo",
    libraries: "places",
  },
});

Vue.directive("click-outside", {
  bind: function (element, binding, vnode) {
    element.clickOutsideEvent = function (event) {
      //  check that click was outside the el and his children
      if (!(element === event.target || element.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event);
        // binding.value(); run the arg
      }
    };
    document.body.addEventListener("click", element.clickOutsideEvent);
  },
  unbind: function (element) {
    document.body.removeEventListener("click", element.clickOutsideEvent);
  },
});
  
  let vm = new Vue({
    el: '#app',
    router: router,
	store,
    render: h => h(App)
  });
  let app = vm.$children[0];

  if (errMsg) {
    app.$router.replace({
      name: 'Error',
      params: {p_message: errMsg}
    });
  }
  else {
    Object.assign(app.d_appInfo, resp.appInfo);
  }
});

